module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-cta"
  }, [(_vm.href) ? _c('router-link', {
    staticClass: "c-cta__link u-relative u-click-area-xxs t-link",
    attrs: {
      "to": _vm.href
    }
  }, [_c('div', {
    staticClass: "u-inline-block"
  }, [_c('div', {
    staticClass: "u-relative u-flex u-flex-jc--center u-flex-ai--center"
  }, [_c('div', {
    staticClass: "c-cta__text-mask u-flex u-overflow-h"
  }, [_c('div', {
    staticClass: "c-cta__text-mask__element u-inline-block u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--light t-text--xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.wordsRegular.join(' ') + '&nbsp;')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--bold t-text--xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.wordsBold)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cta__text-bold-mask u-absolute u-pos-l--0 u-pos-y-center u-inline-block u-overflow-h"
  }, [_c('div', {
    staticClass: "c-cta__text-bold-mask__element u-inline-block u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--bold t-text--xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.wordsRegular.join(' ') + '&nbsp;')
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-cta__border-bottom u-absolute u-pos-bl u-fit-w u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cta__border-bottom--hovered u-absolute u-pos-bl u-fit-w u-bg--brand-gold"
  })]) : (!_vm.href) ? _c('span', {
    staticClass: "u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--light t-text--xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e796d88"}!./src/scripts/components/app-cta/template.html
// module id = 197
// module chunks = 0